const BASE_SELECTOR: string = '.schedule__add';
const SELECT_SELECTOR: string = '[name="data[SchedulerCron][schedule]"]';
const SELECT_RUN_SELECTOR: string = '.js-run';

export class RestartUI {

  private select = this.$base.find(SELECT_SELECTOR);

  public constructor(private $base: JQuery) {
  }

  public onScheduleChange() {
    this.select.on('change', () => {
      const val = this.select.val();

      this.$base.find('div.weekly').hide();
      this.$base.find('div.monthly').hide();

      switch (val) {
        case 'weekly':
          this.$base.find('div.weekly').show();
          break;
        case 'monthly':
          this.$base.find('div.monthly').show();
      }
    })
  }
}

export function createRestartInstances(): RestartUI[] {
  const instances: RestartUI[] = [];

  $(BASE_SELECTOR).each((i, el) => {
    instances.push(new RestartUI($(el)));
  });

  return instances;
}
